
import { Button, Card } from "@mui/material";
import * as React from "react";
import { NavLink } from "react-router-dom";
import { useAppDispatch } from "../../redux/hooks";
import { setEndUserLicenseAgreement } from "../../redux/Slices/company.slice";
import './EndUserLicenseAgreementPage.css'

const cardStyle = {
  position: "absolute",
  margin: "50px",
  padding: "50px"
};



export const EndUserLicenseAgreementPage = () => {
  const dispatch = useAppDispatch();
  const handleAgreeClick = () => {
  dispatch(setEndUserLicenseAgreement(true));
  
  }
  return (
    <Card sx={cardStyle}>
        <h1>The SecQube Portal Terms of Use and EULA</h1>
        <p>
          This Agreement combines clauses of our former End User License Agreement (EULA) 
          and Portal Terms of Use ("<b>Agreement</b>") and is a binding agreement between SecQube 
          Limited (<b>"Company"</b>, <b>"We"</b>, <b>"Us"</b>, <b>"Our"</b>, <b>"Licensor"</b>), a limited company registered in 
          England and Wales with Company Number 15417445, and the specific person and/or 
          entity identified on the invitation to create an account for the Portal (<b>"Customer"</b>, 
          <b>"You"</b>, <b>"Your"</b>, <b>"Licensee"</b>, <b>"Authorised User"</b>). You will find us at our office address: 7 
          Bell Yard, London, England, WC2A 2JR. 
        </p>

        <p>
          The Company provides access to the Portal solely on the terms and conditions set 
          forth in this Agreement, subject to the Customer's acceptance and compliance. By 
          clicking the "accept" button, you:
        </p>

        <p><b>(a)</b> accept this Agreement and agree that you are legally bound by its terms; and</p>
        <p><b>(b)</b> represent and warrant that:</p>
        <ol className="roman">
          <li>you are of legal age to enter into a binding agreement; and</li>
          <li>
            if the Licensee is a corporation, governmental organisation, or other legal entity, 
            you have the right, power, and authority to enter into this Agreement on behalf of 
            the Licensee and bind the Licensee to its terms. If the Licensee does not agree to 
            the terms of this Agreement, the Licensor will not and does not license the 
            software to the Licensee, and you must not download, install, or log into the Portal 
            or the Documentation.
          </li>
        </ol>

        <p>
          Please read these Terms of Use carefully before you start to use the Portal. By using 
          the Portal, you accept and agree to be bound by these Terms of Use. 
        </p>

        <h3>
          IF YOU DO NOT WANT TO AGREE TO THESE TERMS OF USE, YOU MUST NOT 
          ACCESS OR USE THE PORTAL. 
        </h3>

        <p>
          Notwithstanding anything to the contrary in this Agreement or Your or the Licensee’s 
          acceptance of the terms and conditions of this Agreement, this Agreement expressly 
          excludes any right to use the Portal that the Licensee did not acquire lawfully or that is 
          not a legitimate, authorised copy of the Licensor’s Portal. 
        </p>

        <h2>1. Definitions</h2>
        <p>For the purposes of this Agreement, the following terms have the following meanings:</p>

        <p>
          <b>“Authorised User”</b> means solely those individuals authorised to use the Portal 
          pursuant to the license granted under this Agreement. 
        </p>
        
        <p>
          <b>“Documentation”</b> means any user manuals, technical manuals, and any other 
          materials provided by Company, in printed, electronic, or other form, which describe 
          the installation, operation, use, or technical specifications of the Portal. 
        </p>

        <p>
          <b>“Intellectual Property Rights”</b> means any and all registered and unregistered rights 
          granted, applied for, or otherwise now or hereafter in existence under or related to any 
          patent, copyright, trademark, trade secret, database protection, or other intellectual 
          property rights laws, and all similar or equivalent rights or forms of protection, in any 
          part of the world. 
        </p>

        <p>
          “License Fees” means the license fees, including all taxes thereon, paid or required 
          to be paid by the Customer for the license granted under this Agreement as 
          communicated by the Company to the Customer from time to time. 
        </p>

        <p>
          <b>“Parties”</b> means the two parties to this Agreement, namely the Company and the 
          Customer (and all derivatives thereof). 
        </p>

        <p>
          <b>“Person”</b> means an individual, corporation, partnership, joint venture, limited liability 
          company, governmental authority, unincorporated organisation, trust, association, or 
          other entity. 
        </p>

        <p>
          <b>“Portal”</b> means certain aspects of the Company’s software, website, algorithms, 
          methodology, and incorporated intellectual property. 
          “Third Party” means any Person other than the Customer or the Company. 
        </p>

        <h2>2. Acceptance of the Terms of Use</h2>
        <p>
          These Terms of Use are entered into by and between You and the Company. These 
          terms and conditions, together with any documents they expressly incorporate by 
          reference (collectively, <b>“Terms”</b>), govern your access to and use of the services of the 
          Company, including any content, functionality, and services offered on or through the 
          Portal, whether as a guest or an Authorised User. 
        </p>

        <p>
          These Terms of Use are separate from the Terms and Conditions that apply when you 
          use our website at https://secqube.com (<b>“Site”</b>). 
        </p>

        <h2>3. Right to make changes to the Terms of Use</h2>
        <p>
          We may revise and update these Terms of Use from time to time in our sole discretion. 
          All changes take effect immediately upon publication. 
        </p>

        <p>
          Your continued use of the Portal after the publication of revised Terms of Use means 
          you accept and agree to the changes. You are expected to review these Terms from 
          time to time to stay aware of any changes, as they are binding on you. 
        </p>

        <p>
          These Terms were last updated on <b>10 January 2026</b>.
        </p>

        <h2>4. Services</h2>
        <p>
          Subject to the terms and conditions of this Agreement, the Company will deliver to the 
          Customer for the duration of this Agreement, solely for the Customer’s internal 
          business operations: 
        </p>

       
        <ol className="roman">
          <li>
              a non-transferable right to access the Portal;
          </li>  
          <li>
              services provided by the Company to the Customer from time to time if 
              needed (“<b>Consultancy Services</b>”); and</li>  
          <li>
              technical support services in accordance with the Company’s standard 
              practices (“<b>Support Services</b>”). 
          </li>
        </ol>
       

        <p>
          Any services requested by the Customer that fall outside the scope of the Support 
          Services shall be charged for on a commercially reasonable ‘time and materials’ 
          basis, quoted for separately by the Company to the Customer in advance of the 
          delivery of such services and subject to the written agreement of the Parties. The 
          Support Services shall include commercially reasonable endeavours to provide 
          technical support for the identification and resolution of errors or bugs in the Portal 
          for supported web browsers, and may include the provision of training services.
        </p>

        <h2>5. License Grant and Scope</h2>
        <p>
          The Company grants the Customer a limited, non-exclusive, and non-transferable 
          license to use the Portal strictly in accordance with the terms and conditions set forth 
          in this Agreement (the “<b>License</b>”). Subject to the License restrictions set forth in 
          Section 6 hereof, the Company will issue to the Customer a username and password 
          for each Authorised User.
        </p>


        <h2>6. License Restrictions</h2>
        <p>The Customer shall not:</p>
        <ol className="roman">
            <li>copy the Portal.</li>  
            <li>
              modify, translate, adapt, or otherwise create derivative works or 
              improvements, whether or not patentable or copyrightable, of the Portal; 
            </li>  
            <li>
              reverse engineer, disassemble, decompile, decode, or otherwise attempt to 
              derive or gain access to the source code of the Portal or any part thereof; 
            </li>
            <li>
              remove, delete, alter, or obscure any trademarks or any copyright, trademark, 
              patent, or other intellectual property or proprietary rights notices from the 
              Portal, including any copy thereof; 
            </li>
            <li>
              sell, sublicense, assign, distribute, transfer, or otherwise make available the 
              Portal, or any features or functionality of the Portal, to any third party for any 
              reason, including by making the Portal available on a network where it is 
              capable of being accessed by a third party;   
            </li>
            <li>
              remove, disable, circumvent, or otherwise create or implement any 
              workaround to any copy protection, rights management, or security features in 
              or protecting the Portal; 
            </li>
            <li>
              rent, lease, lend, sell, sublicense, assign, distribute, publish, transfer, or 
              otherwise make available the Portal, or any features or functionality of the 
              Portal, to any Third Party for any reason, whether or not over a network or on a 
              hosted basis, including in connection with the internet or any web hosting, 
              wide area network (WAN), virtual private network (VPN), virtualisation, time
              sharing, service bureau, software as a service, cloud, or other technology or 
              service; and 
            </li>
            <li>
              share, distribute, transfer, or otherwise make available any username and/or 
              password issued to each Authorised User.
            </li>
          </ol>

          <h2>7. Access to the Portal and Account Security</h2>
          <p>
            We reserve the right to withdraw or amend this Portal, and any service or material we 
            provide, in our sole discretion, without notice. We will not be liable for any reason if all 
            or any part of the Portal is unavailable at any time or for any period. From time to time, 
            we may restrict access to some or all of the Portal to users, including Authorised 
            Users. 
          </p>

          <p>
            You are responsible and liable for all uses of the Portal and Documentation through 
            which access thereto has been provided by the Customer, directly or indirectly. 
            Specifically, and without limiting the generality of the foregoing, the Customer is 
            responsible and liable for all actions (and failures to take required actions) with 
            respect to the Portal and the Documentation by its Authorised Users or by any other 
            Person to whom the Customer or an Authorised User may provide access to or use of 
            the Portal and/or Documentation, whether such access or use is permitted by or in 
            violation of this Agreement. Furthermore, you are responsible for: 
          </p>
          
          <ul>
            <li>Making all arrangements necessary for you to have access to the Portal.</li>
            <li>Ensuring that all persons who access the Portal through your login credentials are aware of these Terms of Use and comply with them. </li>
          </ul>

          <p>
            To access the Portal or some of its resources, you may be asked to provide certain 
            registration details or other information. It is a condition of your use of the Portal that 
            all the information you provide on the Portal is correct, current and complete. 
          </p>

          <p>
            If you choose, or are provided with, a username, password or any other piece of 
            information as part of our security procedures, you must treat such information as 
            confidential, and you must not disclose it to any other person or entity. You also 
            acknowledge that your account is personal to you and you agree not to provide any 
            other person with access to this Portal or portions of it using your username, 
            password or other security information. You agree to notify us immediately of any 
            unauthorised access to or use of your username or password or any other breach of 
            security. You also agree to ensure you log out of your account at the end of each 
            session. You should use particular caution when accessing your account from a 
            public or shared computer so that others are not able to view or record your password 
            or other personal information. 
          </p>

          <p>
            We have the right to disable any username, password or other identifier, whether 
            chosen by You or provided by us, at any time in our sole discretion for any or no 
            reason, including if, in our opinion, You have violated any provision of these Terms of 
            Use. 
          </p>

          <h2>8. Third-Party Materials</h2>
          <p>
            The Portal may include software, content, data, or other materials, including related 
            documentation, owned by Persons other than the Company and provided to the 
            Customer on Licensee terms that are in addition to and/or different from those 
            contained in this Agreement (“<b>Third-Party Licenses</b>”). Any breach by the Customer or 
            any of its Authorised Users of any Third-Party License is also a breach of this 
            Agreement. 
          </p>

          <h2>9. Compliance Measures</h2>
          <ol className="roman">
            <li>
              The Portal may contain technological copy protection or other security features 
              designed to prevent unauthorised use of the Portal, including features to 
              protect against any use of the Portal that is prohibited under Section 12. The 
              Customer shall not, and shall not attempt to remove, disable, circumvent, or 
              otherwise create or implement any workaround to, any such copy protection or 
              security features. 
            </li>
            <li>
              During the Term of this Agreement, the Company may, in the Company’s sole 
              discretion, audit the Customer’s use of the Portal to ensure the Customer’s 
              compliance with this Agreement. 
            </li>
            <li>
              <p>
                If the audit or any of the measures taken or implemented under this Section 9 
                determines that the Customer’s use of the Portal exceeds the use permitted by 
                this Agreement, then: <br/>

                The Customer shall, within three (3) days following the date of the Company’s 
                written notification thereof, pay to the Company the retroactive License Fees 
                for such excess use and, unless the Company terminates this Agreement, 
                obtain and pay for a valid license to bring the Customer’s use into compliance 
                with this Agreement. In determining the Customer fee payable pursuant to the 
                foregoing, 
              </p>
              <p>
                <b>(a)</b> unless the Customer can demonstrate otherwise by documentary evidence, 
                all excess use of the Portal shall be deemed to have commenced on the 
                commencement date of this Agreement or, if later, the completion date of any 
                audit previously conducted by the Company hereunder, and continued 
                uninterrupted thereafter; and 
              </p>
              <p>
                <b>(b)</b> the rates for such licenses shall be determined without regard to any 
                discount to which the Customer may have been entitled had such use been 
                properly licensed prior to its commencement (or deemed commencement). 
                The Company’s remedies set forth in this Section 9 are cumulative and are in addition 
                to, and not in lieu of, all other remedies the Company may have at law or in equity, 
                whether under this Agreement or otherwise.
              </p>
            </li>
          </ol>

          <h2>10. Collection and Use of Information</h2>
          <ol className="roman">
            <li>
              The Customer acknowledges that the Company may, directly or indirectly 
              through the services of Third Parties, collect and store information regarding 
              use of the Portal and about equipment on which the Portal is installed or 
              through which it otherwise is accessed and used, through the security 
              measures included in the Portal as described in Section 7, and any other 
              means described in the Company’s privacy policy, located at 
              https://www.secqube.com/privacy-policy (“Privacy Policy”). 
            </li>
            <li>
              <p>
                The Customer agrees that the Company may use such information for any 
                purpose related to any use of the Portal by the Customer or on the Customer’s 
                equipment, including but not limited to: 
              </p>
              <p>
                <b>(a)</b> improving the performance of the Portal or developing updates; and 
              </p>
              <p>
                <b>(b)</b> verifying the Customer’s compliance with the terms of this Agreement 
                and enforcing the Company’s rights, including all Intellectual Property 
                Rights in and to the Portal.
              </p>
            </li>
          </ol>

          <h2>11. Intellectual Property Rights</h2>
          <p>
            The Portal and its entire contents, features and functionality (including but not limited 
            to all information, software, text, displays, images, video and audio, and the design, 
            selection and arrangement thereof), are owned by the Company, its Licensors or 
            other providers of such material and, where possible, are protected by UK and 
            international copyright, trademark, patent, trade secret and other intellectual 
            property or proprietary rights laws. 
          </p>

          <p>
            These Terms of Use permit you to use the Portal solely for your internal business 
            purposes (and, for individuals, on behalf of the Customer in connection with the 
            Customer’s internal business operations) in accordance with this Agreement. You 
            must not reproduce, distribute, modify, create derivative works of, publicly display, 
            publicly perform, republish, download, store or transmit any of the material on our 
            Portal, except as follows: 
          </p>

          <ul>
            <li>
              If we provide desktop, mobile or other applications for download, you may 
              download a single copy to your computer or mobile device solely for internal 
              business purposes in connection with use of the Portal, provided you agree to 
              be bound by our end-user license agreement for such applications. 
            </li>
            <li>
              Your computer may temporarily store copies of such materials in RAM 
              incidental to your accessing and viewing those materials. 
            </li>
            <li>
              You may store files that are automatically cached by your Web browser for 
              display enhancement purposes. 
            </li>
            <li>
              You may print one copy of a reasonable number of pages of the Portal for 
              internal business purposes and not for further reproduction, publication or 
              distribution. 
            </li>
          </ul>
          <p>You must not:</p>
          <ul>
            <li>Modify copies of any materials from the Portal.</li>
            <li>Delete or alter any copyright, trademark or other proprietary rights notices from 
                copies of materials from the Portal.</li>
          </ul>

          <p>
            You must not access or use any part of the Portal or any services or materials 
            available through the Portal other than for the Customer’s internal business purposes 
            as permitted by this Agreement. 
          </p>
          
          <p>
            If you print, copy, modify, download or otherwise use or provide any other person with 
            access to any part of the Portal in breach of the Terms of Use, your right to use the 
            Portal will cease immediately, and you must, at our option, return or destroy any 
            copies of the materials you have made. No right, title or interest in or to the Portal or 
            any content on the Portal is transferred to you, and all rights not expressly granted are 
            reserved by the Company. Any use of the Portal not expressly permitted by these 
            Terms of Use is a breach of these Terms of Use and may violate copyright, trademark 
            and other laws. 
          </p>

          <h2>12. Prohibited Uses</h2>
          <p>
            You may use the Portal only for lawful purposes and in accordance with these Terms 
            of Use. You agree not to use the Portal: 
          </p>
          
          <ul>
              <li>
                In any way that violates any applicable local or international law or regulation 
                (including, without limitation, any laws regarding the export of data or software 
                to and from the UK or other countries).
              </li>
              <li>
                For the purpose of exploiting, harming or attempting to exploit or harm minors 
                in any way by exposing them to inappropriate content, asking for personally 
                identifiable information or otherwise.
              </li>
              <li>
                To transmit, or procure the sending of, any advertising or promotional material, 
                including any “junk mail,” “chain letter,” “spam,” or any other similar 
                solicitation. 
              </li>
              <li>
                To impersonate or attempt to impersonate the Company, a Company 
                employee, another user or any other person or entity (including, without 
                limitation, by using e-mail addresses associated with any of the foregoing).
              </li>
              <li>
                To engage in any other conduct that restricts or inhibits anyone’s use or 
                enjoyment of the Portal, or which, as determined by us, may harm the 
                Company or users of the Portal, or expose them to liability. 
              </li>
          </ul>
          <p>Additionally, you agree not to: </p>

          <ul>
            <li>
              Use the Portal in any manner that could disable, overburden, damage, or impair 
              the Portal or interfere with any other party’s use of the Portal, including their 
              ability to engage in real-time activities through the Portal. 
            </li>
            <li>
              Use any robot, spider or other automatic device, process or means to access 
              the Portal for any purpose, including monitoring or copying any of the material 
              on the Portal. 
            </li>
            <li>
              Use any manual process to monitor or copy any of the material on the Portal, or 
              for any other purpose not expressly authorised in these Terms of Use, without 
              our prior written consent. 
            </li>
            <li>
              Use any device, software or routine that interferes with the proper working of 
              the Portal. 
            </li>
            <li>
              Introduce any viruses, Trojan horses, worms, logic bombs or other material 
              which is malicious or technologically harmful.
            </li>
            <li>
              Attempt to gain unauthorised access to, interfere with, damage or disrupt any 
              parts of the Portal, the device on which the Portal is accessed, or any server, 
              computer or database connected to the Portal. 
            </li>
            <li>
              Attack the Portal via a denial-of-service attack or a distributed denial-of
              service attack. 
            </li>
            <li>
              Otherwise, attempt to interfere with the proper working of the Portal. 
            </li>
          </ul>

          <h2>13. User Contributions</h2>
          <p>
            The Portal may contain message boards, chat rooms, personal web pages or profiles, 
            forums, bulletin boards, and other interactive features (collectively, “<b>Interactive 
            Services</b>”) that allow users to post, submit, publish, display or transmit to other users 
            or other persons (hereinafter, “post”) content or materials (collectively, “User 
            Contributions”) on or through the Portal. 
          </p>

          <p>
            All User Contributions must comply with the Content Standards set out at paragraph 
            14 in these Terms of Use. 
          </p>

          <p>
            Any User Contribution You post to the site will be considered non-confidential and 
            non-proprietary. By providing any User Contribution on the Portal, you grant us and 
            our affiliates and service providers, and each of their and our respective Licensees or 
            successors and assigns, the right to use, reproduce, modify, perform, display, 
            distribute and otherwise disclose to third parties any such material for any purpose. 
          </p>

          <p>You represent and warrant that: </p>

          <ul>
            <li>
              You own or control all rights in and to the User Contributions and have the right 
              to grant the license granted above to us and our affiliates and service 
              providers, and each of their and our respective licensees, successors and 
              assigns. 
            </li>
            <li>
              All of your User Contributions do and will comply with these Terms of Use. 
            </li>
          </ul>

          <p>
            You understand and acknowledge that you are responsible for any User Contributions 
            you submit or contribute, and you, not the Company, have full responsibility for such 
            content, including its legality, reliability, accuracy, and appropriateness. 
          </p>

          <p>
            We are not responsible, or liable to any third party, for the content or accuracy of any 
            User Contributions posted by you or any other user of the Portal. 
          </p>

          <h2>14. Content Standards</h2>
          <p>
            These content standards (the “Content Standards”) apply to any and all User 
            Contributions and use of Interactive Services. User Contributions must, in their 
            entirety, comply with all applicable local and international laws and regulations. 
            Without limiting the foregoing, User Contributions must not: 
          </p>
          
          <ul>
            <li>
              Contain any material that is defamatory, obscene, indecent, abusive, 
              offensive, harassing, violent, hateful, inflammatory, or otherwise 
              objectionable. 
            </li>
            <li>
              Promote sexually explicit or pornographic material, violence, or discrimination 
              based on race, sex, religion, nationality, disability, sexual orientation, or age. 
            </li>
            <li>
              Infringe any patent, trademark, trade secret, copyright, or other intellectual 
              property or other rights of any other person. 
            </li>
            <li>
              Violate the legal rights (including the rights of publicity and privacy) of others or 
              contain any material that could give rise to any civil or criminal liability under 
              applicable laws or regulations or that otherwise may be in conflict with 
              these Terms of Use and our Privacy Policy. 
            </li>
            <li>Be likely to deceive any person.</li>
            <li>
              Promote any illegal activity, or advocate, promote, or assist any unlawful act. 
            </li>
            <li>
              Cause annoyance, inconvenience, or needless anxiety or be likely to upset, 
              embarrass, alarm, or annoy any other person. 
            </li>
            <li>
              Impersonate any person or misrepresent your identity or affiliation with any 
              person or organisation. 
            </li>
            <li>
              Involve commercial activities or sales, such as contests, sweepstakes, and 
              other sales promotions, barter, or advertising. 
            </li>
            <li>
              Give the impression that they emanate from or are endorsed by us or any other 
              person or entity, if this is not the case. 
            </li>
          </ul>

          <h2>15. Reliance on Information Posted</h2>
          <p>
            The information presented on or through the Portal is made available solely for 
            general information purposes. We do not warrant the accuracy, completeness or 
            usefulness of this information. Any reliance you place on such information is strictly 
            at your own risk. We disclaim all liability and responsibility arising from any reliance 
            placed on such materials by you or any other visitor to the Portal, or by anyone who 
            may be informed of any of its contents. 
          </p>

          <p>
            This Portal may include content provided by third parties, including materials from 
            other users, bloggers, and third-party licensors, syndicators, aggregators, and/or 
            reporting services. All statements and/or opinions expressed in these materials, and 
            all articles and responses to questions and other content, other than the content 
            provided by the Company, are solely the opinions and the responsibility of the person 
            or entity providing those materials. These materials do not necessarily reflect the 
            opinion of the Company. We are not responsible, or liable to you or any third party, for 
            the content or accuracy of any materials provided by any third parties. 
          </p>

          <h2>16. Geographic Restrictions</h2>
          
          <p>
            The owner of the Portal is based in the United Kingdom. We make no claims that the 
            Portal or any of its content is accessible or appropriate outside of the United Kingdom. 
          </p>

          <p>
            The Portal is available in multiple jurisdictions globally. Access to your local 
            jurisdiction/region is selected up front during the signup process. Security measures 
            may mean that access to the Portal is not possible outside your chosen jurisdiction. 
            Access to the Portal may not be legal for certain persons or in certain countries. 
            Whenever and wherever You access the Portal, You do so on Your own initiative and 
            are responsible for compliance with local laws. 
          </p>

          <h2>17. Term</h2>
          <p>
            The term of this Agreement shall commence on the date when the first License Fee 
            payment is made and shall continue until terminated by the Company or the 
            Customer by providing 30 days’ notice (90 days in the case of Annual Licenses) of 
            such termination to the non-terminating party (the “<b>Term</b>”). 
          </p>

          <h2>18. License Fees</h2>
          <ol className="roman">
            <li>
              <p>
                In consideration of the limited, non-exclusive and non-transferable License 
                granted to the Customer hereunder, the Customer agrees to pay the Company 
                the license fees as implemented and charged by the Company from time to 
                time (collectively, the “<b>License Fees</b>”). 
              </p>
              <p>
                Customer shall pay all License Fees on a monthly basis in advance (unless the 
                Customer elects Annual Licensing, in which case the License Fees shall be 
                paid annually in advance) using the payment information provided by the 
                Company to the Customer.  
              </p>
              <p>
                The first billing period for any upgrade or expansion of the Services will include 
                a prorated charge for the time period. The Customer shall make all payments 
                hereunder via credit card payment, which shall be provided to the Company, 
                and the Company is hereby authorised to automatically charge such credit 
                card without further authorisation for all License Fees and other fees incurred 
                by the Customer until such time that the Customer provides written notice that 
                the Company is no longer authorised to charge such credit card; provided, 
                further, that if the Customer does not have an authorised credit card on file 
                with the Company, the Company may, in addition to all other remedies 
                available to the Company, terminate or suspend the Customer’s access to the 
                Portal. 
              </p>
              <p>
                The Customer shall be responsible for all applicable taxes included with the 
                License Fees, and any other similar taxes, duties and charges of any kind 
                imposed by any international, state, or local governmental or regulatory 
                authority on any amounts payable by the Customer hereunder, other than any 
                taxes imposed on the Company’s income. 
              </p>
            </li>
            <li>
              <p>
                If the Customer fails to make any payment when due, then, in addition to all 
                other remedies that may be available to the Company: 
              </p>
              <ol className="alpha">
                  <li>
                    The Company may charge interest on the past due amount at the rate of 
                    1.5% per month, calculated daily and compounded monthly or, if lower, 
                    the highest rate permitted under applicable law; 
                  </li>
                  <li>
                    The Customer shall reimburse the Company for all reasonable costs 
                    incurred by the Company in collecting any late payment of amounts due 
                    or related interest, including legal fees, court costs, and collection 
                    agency fees; and 
                  </li>
                  <li>
                    The Company may:<br/>
                    <b>(1)</b> disable the Customer’s use of the Portal;<br/>
                    <b>(2)</b> withhold, suspend or revoke its grant of the License hereunder; and/or  <br/>
                    <b>(3)</b> terminate this Agreement. 
                  </li>
              </ol>
            </li>
            <li>
              The Company may, in its sole discretion, adjust the License Fee upon thirty (30) 
              days' written notice to the Customer, but in no event shall the Company 
              increase the License Fee more than once per calendar year.  Such adjusted 
              License Fee shall apply to all invoices after the effective date of the License 
              Fee increase. 
            </li>
            <li>
              The Customer agrees to keep all License Fees and related pricing information 
              confidential and will not disclose such information to any third parties without 
              the Company’s prior written consent.  The Customer agrees to take all 
              reasonable measures to protect the confidentiality of and avoid disclosure of 
              such confidential information in order to prevent it from falling into the public 
              domain or the possession of third parties, which measures shall include the 
              highest degree of care that it utilises to protect its own confidential information 
              of a similar nature. 
            </li>
          </ol>

          <h2>19. Monitoring and Enforcement; Termination</h2>
          We have the right to: 
          <ul>
            <li>
              Remove or refuse to post any User Contributions for any or no reason in our 
              sole discretion. 
            </li>
            <li>
              Take any action with respect to any User Contribution that we deem necessary 
              or appropriate in our sole discretion, including if we believe that such User 
              Contribution violates the Terms of Use, including the Content Standards, 
              infringes any intellectual property right or other right of any person or entity, 
              threatens the personal safety of users of the Portal or the public or could 
              create liability for the Company. 
            </li>
            <li>
              Disclose Your identity or other information about You to any third party who 
              claims that material posted by You violates their rights, including their 
              intellectual property rights or their right to privacy. 
            </li>
            <li>
              Take appropriate legal action, including, without limitation, referral to law 
              enforcement, for any illegal or unauthorised use of the Portal. 
            </li>
            <li>
              Terminate or suspend your access to all or part of the Portal for any or no 
              reason, including, without limitation, any violation of these Terms of Use. 
            </li>
          </ul>

          <p>
            Without limiting the foregoing, we have the right to fully cooperate with any law 
            enforcement authorities or court order that requests or directs us to disclose the 
            identity or other information of anyone who posts materials on or through the Portal. 
            You waive and hold harmless the Company and its affiliates, Licensees and service 
            providers from any claims resulting from any action taken by any of the foregoing 
            parties during or as a result of its investigations and from any actions taken as a 
            consequence of investigations by either such parties or law enforcement authorities. 
          </p>

          <p>
            However, we do not undertake to review all material before it is posted on the Portal 
            and cannot ensure prompt removal of objectionable material after it has been posted. 
            Accordingly, we assume no liability for any action or inaction regarding transmissions, 
            communications, or content provided by any user or third party. We have no liability or 
            responsibility to anyone for performance or non-performance of the activities 
            described in this Section. 
          </p>

          <p>
            Except for in cases of nonpayment, which shall be remedied in accordance with 
            Section 18(2) above, either party may terminate this Agreement upon thirty (30) days' 
            written notice to the other party, if the other party (the “Breaching Party”) materially 
            breaches this Agreement, and  
          </p>

          <ol className="roman">
            <li>such material breach is incapable of cure, or </li>
            <li>
              the Breaching Party does not cure such material breach within thirty (30) days after 
              receipt of written notice of such breach.
            </li>
          </ol>

          <p>
            Upon termination, all rights granted to the Customer under this Agreement will 
            terminate, and the Customer must cease all use of the Portal and delete all copies of 
            the Portal in its possession. Termination shall not limit any of the Company’s rights or 
            remedies at law or in equity.  
          </p>

          <p>
            The Parties shall resolve any dispute, controversy, or claim arising out of or relating to 
            this Agreement, or the breach, termination, or invalidity hereof (each, a “<b>Dispute</b>”), 
            under the provisions of Sections 20(B) and 20(C). The procedures set forth in Sections 
            20(B) and 20(C) shall be the exclusive mechanism for resolving any Dispute that may 
            arise. 
          </p>

          <p>
            A party shall send written notice to the other party of any Dispute (“<b>Dispute Notice</b>”). 
            The Parties shall first attempt in good faith to resolve any Dispute set forth in the 
            Dispute Notice by negotiation and consultation between themselves, including not 
            fewer than two (2) negotiation sessions.  
          </p>

          <h2>20. Dispute Resolution & Mediation.</h2>
          <ol className="roman">
            <li>
              Subject to Section 20(C), the Parties may, at any time after the two (2) 
              negotiation sessions, submit the Dispute to any mutually agreed-upon 
              mediation service for mediation by providing to the mediation service a joint, 
              written request for mediation, setting forth the subject of the Dispute and the 
              relief requested. The Parties shall cooperate with one another in selecting a 
              mediation service and shall cooperate with the mediation service and with one 
              another in selecting a neutral mediator and in scheduling the mediation 
              proceedings. The Parties covenant to use commercially reasonable efforts to 
              participate in the mediation. The Parties agree that the mediator’s fees and 
              expenses and the costs incidental to the mediation will be shared equally 
              between the Parties. 
            </li>
            <li>
              The Parties further agree that all offers, promises, conduct, and statements, 
              whether oral or written, made in the course of the mediation by any of the 
              Parties, their agents, employees, experts, and attorneys, and by the mediator 
              and any employees of the mediation service, are confidential, privileged, and 
              inadmissible for any purpose, including impeachment, in any litigation, 
              arbitration, or other proceeding involving the Parties, provided that evidence 
              that is otherwise admissible or discoverable shall not be rendered inadmissible 
              or non-discoverable as a result of its use in the mediation. 
            </li>
            <li>
              If the Parties cannot resolve any Dispute for any reason, including, but not 
              limited to, the failure of either party to agree to enter into mediation or agree to 
              any settlement proposed by the mediator, within ten (10) days of the 
              conclusion of the proposal or two (2) negotiation sessions, respectively, either 
              party may file suit in the courts of England and Wales. 
            </li>
          </ol>

          <h2>21. No Deductions or Setoffs.</h2>
          <p>
            All amounts payable to the Company under this Agreement shall be paid by the 
            Customer to the Company in full without any setoff, recoupment, counterclaim, 
            deduction, debt or withholding for any reason.   
          </p>

          <h2>22. Incident Reporting.</h2>
          <ol className="roman">
            <li>
              The Company reports on an incident with the data and information available at 
              the time of writing the incident. An incident status can change quickly; any 
              changes to the situation will alter the original level; the Company cannot 
              accept liability for this. 
            </li>
            <li>
              The Company does not accept liability for any ransomware, malware, viruses, 
              spyware, or any such malicious software. Although the Company will report 
              vulnerabilities to the Customer within 24 hours of discovery, the nature of the 
              exposure indicates a weakness in the Customer’s systems that the Company is 
              monitoring and is not responsible for. 
            </li>
            <li>
              The Company strongly recommends that the Customer patch or fix the 
              vulnerabilities by any means supported by the vendor supplying the solution 
              with the vulnerability. 
            </li>
            <li>
              The Company is not responsible for patching the Customer systems. 
            </li>
            <li>
              Customer Indemnification. To the fullest extent permitted by law, the 
              Customer shall defend, indemnify and hold the Company and its indemnitees 
              harmless from and against any claims, actions, damages, expenses (including 
              reasonable legal fees), losses, or liabilities incurred by or asserted against the 
              Company or any of its indemnitees for injury (including death) to persons or 
              damage or destruction to property and any fees, costs or penalties incurred by 
              the Company or any of its indemnitees, to the extent that such claims, actions, 
              damages, expenses, losses, liabilities, fees, costs or penalties are caused by 
              or arise out of the Customer’s actions related to such reports; provided that 
              the Customer shall not be required to indemnify the Company or any of its 
              indemnitees for any loss or claim to the extent such failure or claim is due to 
              the gross negligence or wilful misconduct of the Company or any of its 
              indemnitees. 
            </li>
          </ol>

          <h2>23. Usernames and Passwords; 24 Hour Notice Requirement.</h2> 
          
          <ol className="numbered">
            <li>
              <p>The Customer must immediately notify the Company of:</p>
              <ol className="roman">
                <li>any request to increase or decrease the number of Authorised User(s);</li>
                <li>
                    known or suspected unauthorised use(s) of each Authorised User’s 
                    username and/or password; and
                </li>
                <li>
                  <p>
                    any known or suspected breach of security, including the loss, theft, or 
                    unauthorised disclosure of such username and/or password or any 
                    unauthorised access to the Portal. 
                  </p>
                </li>
              </ol>
            </li>
            <li>
                <p>
                  The Portal may contain technological measures designed to prevent unauthorised 
                  or illegal use of the Portal. The Customer acknowledges and agrees that:  
                </p>
                <ol className="roman">
                  <li>
                    The Company may use these and other lawful measures to verify the 
                    Customer’s compliance with the terms of this Agreement and enforce the 
                    Company’s rights, including all Intellectual Property Rights, in and to the Portal; 
                    and 
                  </li>
                  <li>
                    <p>
                      The Company may deny any individual access to and/or use of the Portal if 
                      the Company, in its sole discretion, believes that person’s use of the Portal 
                      would violate any provision of this Agreement, regardless of whether the 
                      Customer designated that person as an Authorised User. This information will 
                      be treated in accordance with the Company’s privacy policy, as amended from 
                      time to time. 
                    </p>
                  </li>
                </ol>
            </li>
            <li>
              The Customer shall provide to the Company a minimum of twenty-four (24) hours' 
              written notice prior to implementing any changes which could directly or indirectly 
              impact the Company's ability to perform its obligations to the Customer as 
              contemplated by this Agreement. 
            </li>
          </ol>

          <h2>24. Personal Information & Anonymisation of Data.</h2>
          <ol className="numbered">
                <li>
                  The Company will comply with applicable laws and regulations in its creation, 
                  collection, receipt, access, use, storage, disposal, and disclosure of Personal 
                  Information. The Company will employ reasonable security measures to protect 
                  Personal Information in accordance with accepted industry standards. If, in the 
                  course of its performance under this Agreement, the Company has access to or will 
                  collect, access, use, store, process, dispose of, or disclose credit, debit, or other 
                  payment cardholder information on the Customer’s behalf, the Company will comply 
                  with the Payment Card Industry Data Security Standard (“PCI DSS”) requirements, as 
                  applicable.  For the purposes of this Agreement, “Personal Information” means 
                  information that the Customer provides or for which the Customer provides access to 
                  the Company, or information which the Company creates or obtains on behalf of the 
                  Customer, in accordance with this Agreement that:<br/>
                  <ol className="roman">
                    <li>directly or indirectly identifies an individual; or</li>
                    <li>can be used to authenticate an individual (including, without limitation, 
                      employee identification numbers, government-issued identification numbers, 
                      passwords or PINs, user identification and account access credentials or 
                      passwords, financial account numbers, credit report information, student 
                      information, biometric, genetic, health, or health insurance data, answers to 
                      security questions, and other personal identifiers). Customer’s business 
                      contact information is not by itself Personal Information. 
                    </li>
                  </ol>
                </li>
                <li>
                  By entering into this Agreement and by using the Services, the Customer consents 
                  to, and hereby agrees that the Company may access the Customer’s networks and 
                  computer systems, including the use, disclosure, interception, transmission, receipt, 
                  analysis, processing, copying, editing, encryption, decryption, and storage of the 
                  Customer’s information and that of its employees, agents, and those it authorises to 
                  use the Services, whether encrypted or in clear text (“Customer’s Information”), for 
                  the purpose of providing the Services, including, without limitation, analysing the 
                  Customer’s network traffic, and for storage and retention of the Customer’s 
                  Information for future reference and analysis. The Customer represents and warrants 
                  that it complies with all applicable data collection and transfer laws and regulations 
                  of the countries in which it operates and that it has duly obtained all consents, 
                  permits, or licenses, in writing or electronically, that may be necessary under 
                  applicable laws from its employees, agents, and those it authorises to use the 
                  Services in order to enable the Company to provide the Services under the 
                  Agreement. Prior to using the Services, or at any other time reasonably determined by 
                  the Company, the Customer will provide the Company true and correct copies of such 
                  consents. 
                </li>
                <li>
                  In the course of providing the use of the Portal to the Customer, the Company may 
                  collect, maintain and/or generate information derived from the Customer’s use of the 
                  Portal (“Derivative Data”), provided that  
                  <ol className="roman">
                      <li>
                        such information has been anonymised in accordance with industry 
                        standards and any applicable laws and  
                      </li>
                      <li>
                        neither the Customer nor any natural person can be identified through 
                        analysis of the Derivative Data.  The Derivative Data is not Customer data or 
                        information, and the Company may process the Derivative Data for purposes 
                        other than the performance of the Portal.  The Derivative Data may be retained 
                        beyond the Term of this Agreement. 
                      </li>
                  </ol>
                </li>
          </ol>

          <h2>25. Disclaimer of Warranties</h2>
          <p>
            You understand that we cannot and do not guarantee or warrant that files available for 
            downloading from the internet or the Portal will be free of viruses or other destructive 
            code. You are responsible for implementing sufficient procedures and checkpoints to 
            satisfy your specific requirements for antivirus protection and the accuracy of data 
            input and output, and for maintaining an external means for reconstructing any lost 
            data.  
          </p>
          <p>
            We will not be liable for any loss or damage caused by a distributed denial-of-service 
            attack, viruses or other technologically harmful material that may infect your 
            computer equipment, computer programs, data or other proprietary material due to 
            your use of the Portal or any services or items obtained through the Portal or to your 
            downloading of any material posted on it, or on any portal linked to it. 
          </p>

          <p>
            Your use of the Portal, its content and any services or items obtained through the 
            Portal is at your own risk. The Portal, its content and any services or items obtained 
            through the Portal are provided on an “as is” and “as available” basis, without any 
            warranties of any kind, either express or implied. Neither the Company nor any person 
            associated with the Company makes any warranty or representation regarding the 
            completeness, security, reliability, quality, accuracy, or availability of the Portal.  
          </p>

          <p>
            Without limiting the foregoing, neither the Company nor anyone associated with the 
            Company represents or warrants that the Portal, its content or any services or items 
            obtained through the Portal will be accurate, reliable, error-free or uninterrupted, that 
            defects will be corrected, that our site or the server that makes it available are free of 
            viruses or other harmful components or that the Portal or any services or items 
            obtained through the Portal will otherwise meet your needs or expectations. 
          </p>

          <p>
            The Company hereby disclaims all warranties of any kind, whether express or implied, 
            statutory or otherwise, including but not limited to any warranties of merchantability, 
            non-infringement and fitness for particular purpose. 
          </p>

          <p>
            The foregoing does not affect any warranties which cannot be excluded or limited 
            under applicable law. 
          </p>

          <h2>26. Limitation on Liability</h2>

          <p>
            To the fullest extent provided by law, in no event will the Company, its affiliates or 
            their Licensors, service providers, employees, agents, officers or directors be liable 
            for damages of any kind, under any legal theory, arising out of or in connection with 
            your use, or inability to use, the Portal, any websites linked to it, any content on the 
            website or such other websites or any services or items obtained through the Portal or 
            such other websites, including any direct, indirect, special, incidental, consequential 
            or punitive damages, including but not limited to, personal injury, pain and suffering, 
            emotional distress, loss of revenue, loss of profits, loss of business or anticipated 
            savings, loss of use, loss of goodwill, loss of data, and whether caused by tort 
            (including negligence), breach of contract or otherwise, even if foreseeable. 
          </p>

          <p>
            In no event will the Company’s and its affiliates’, including any of its or their respective 
            companies’ and service providers’, collective aggregate liability under or in connection 
            with this Agreement or its subject matter, under any legal or equitable theory, 
            including breach of contract, tort (including negligence), strict liability, and otherwise, 
            exceed the total amount paid to the Company pursuant to this Agreement for the six 
            (6) month period preceding the subject of the claim. 
          </p>

          <p>
            The foregoing does not affect any liability which cannot be excluded or limited under 
            applicable law. 
          </p>

          <h2>27. Mutual Confidentiality and Nondisclosure.</h2>
          <p>
            <b><br/>1. Access<br/></b>
            Subject to all of the terms of this Agreement, each party is willing to disclose certain 
            Confidential Information to the other solely for the Permitted Purpose (defined below 
            in this Section 27.1.(a)). The Term “<b>Confidential Information</b>” means any and all 
            financial, business, marketing, operations, scientific or technological information, 
            and trade secrets, whether tangible or intangible (including all originals, copies, 
            digests and summaries in any media or form), and including without limitation 
            customer and prospective customer information and data, or any business plans or 
            related information or data, now or previously disclosed by a party (“<b>Discloser</b>”) to the 
            other party (“<b>Recipient</b>”) or by any of Discloser’s employees, agents, or contractors, 
            orally or in writing or by way of any other media and, that is marked or otherwise 
            identified as “<b>Confidential Information</b>” at the time of disclosure or which the 
            Recipient should reasonably understand to be Confidential Information of the 
            Discloser.  
          </p>
          <p>
            Confidential Information does not include any information that: (a) is 
            known to or in the possession of the Recipient before receipt thereof under this 
            Agreement; (b) is disclosed to the Recipient by a third person who has a right to make 
            such disclosure without any obligation of confidentiality to the Discloser or any other 
            third party; (c) is or becomes part of the public domain or generally known in the 
            trade, in either case, without violation of this Agreement by the Recipient; or (d) is 
            independently developed by the Recipient or Recipient’s employees or contractors 
            without use of or reference to any Confidential Information disclosed to such 
            Recipient; provided (i) such Recipient shall bear the burden of establishing any of the 
            foregoing exclusions; and (ii) only the specific Confidential Information that meets the 
            exclusions shall be excluded, and not any other Confidential Information that 
            happens to appear in proximity to such excluded portions (for example, a portion of a 
            document may be excluded without affecting the confidential nature of those portions 
            that do not themselves qualify for exclusion). 
          </p>
          <p>
            The term “<b>Permitted Purpose</b>” means 
            consideration of a business relationship or transaction between the parties, and any 
            resulting relationship or transaction, but not Recipient’s use outside of such 
            relationship or transaction. 
          </p>

          <p>
            <b>2. Confidentiality.  <br/></b>
            Each Recipient agrees (i) to keep secret and maintain the Confidential Information as 
            confidential; (ii) to use the Confidential Information solely for the Permitted Purpose; 
            (iii) to segregate the Confidential Information from the Recipient’s other information 
            and that of third parties; (iv) not to copy the Confidential Information, except as 
            otherwise required by the Permitted Purpose or as agreed to by Discloser; (v) promptly 
            notify, if legally permitted, the Discloser upon learning about any court order or other 
            legal requirement that purports to compel disclosure by Recipient or any of its 
            employees, agents or contractors of any Confidential Information and to reasonably 
            cooperate with the Discloser in the exercise of the Discloser’s right to protect the 
            confidentiality of the Confidential Information before any tribunal or governmental 
            agency; (vi) not to disclose the Confidential Information to any person or entity not a 
            party to this Agreement other than such of Recipient’s contractors, agents or 
            employees who (A) have a need to know the Confidential Information for the Permitted 
            Purpose and (B) are apprised of the confidential nature of the Confidential 
            Information; provided, further, Recipient shall use best efforts to prevent the 
            disclosure of Confidential Information to any contractor or agent who may be a direct 
            or indirect competitor of Discloser, but may have circumstantial or partial access to 
            the Confidential Information; (vii) to exercise all reasonable precautions to prevent 
            unauthorised access to the Confidential Information in its possession or in the 
            possession of its employees, agents, or contractors; and (viii) to destroy or return 
            promptly to the Discloser at any time upon the Discloser’s written request, any and all 
            Confidential Information and copies thereof received from the other party.
          </p>

          <p>
            Each party shall cause its employees, agents and contractors to observe the provisions of this 
            Agreement as if they were a party thereto, and Recipient shall be responsible for any 
            violation of the covenants of this Agreement by its employees, agents and contractors 
            which shall be deemed a breach of this Agreement by Recipient. Disclosure of 
            Confidential Information pursuant to a court order or other legal requirement that 
            purports to compel disclosure of any Confidential Information shall not alter the 
            character of that information as Confidential Information hereunder; provided, 
            however, that Recipient or any of its employees, agents or contractors may disclose 
            Confidential Information as required by any court order or other legal requirement, 
            provided that Recipient complies with clause (v) of the first sentence of this Section 
            27.2. If Discloser is not successful in obtaining a protective order with respect to such 
            Confidential Information, Recipient shall furnish only that portion of the Confidential 
            Information that is legally required and will exercise all reasonable efforts to obtain 
            reliable assurances that confidential treatment will be accorded the Confidential 
            Information. 
          </p>

          <p>
            <b>3. No Licenses.  <br/></b>
            All of the Discloser’s rights in and to the Confidential Information disclosed hereunder 
            by it shall remain the exclusive property of the Discloser and neither this Agreement, 
            nor any disclosure of Confidential Information hereunder, in any way: (i) grants to 
            Recipient any right or license under any copyright, patent, mask work or trademark 
            now or hereafter owned or controlled by Discloser; (ii) obligates either party to 
            disclose or receive any Confidential Information, perform any work, enter into any 
            license, business engagement or other agreement; (iii) creates any joint relationship 
            or authorises either party to act or speak on behalf of the other; (iv) limits either party 
            from entering into any business relationship with any third party; or (v) creates any 
            warranties, including without limitation any warranties as to accuracy or 
            completeness of any Confidential Information. 
          </p>

          <p>
            <b>4. Termination.  <br/></b>
            The confidentiality obligations of this Agreement, as they apply to Confidential 
            Information disclosed prior to termination, shall survive termination for a period of 
            three (3) years. Upon termination of this Agreement, each party shall destroy or 
            promptly return to the other or securely destroy all Confidential Information and 
            copies thereof received from the other Party. 
          </p>

          <p>
            <b>5. Equitable Remedies. <br/></b>
            The parties agree that any breach or threatened breach of this Agreement by a 
            Recipient would cause not only financial harm, but irreparable harm to the Discloser 
            and that money damages may not provide an adequate remedy. In the event of a 
            breach or threatened breach of this Agreement by a Recipient, the Discloser shall, in 
            addition to any other rights and remedies it may have at law or in equity, be entitled to 
            an injunction restraining the Recipient from disclosing or using, in whole or in part, 
            any Confidential Information. 
          </p>

          <h2>28. Indemnification </h2>
          <p>
            You agree to defend, indemnify and hold harmless the Company, its affiliates, 
            Licensors and service providers, and its and their respective officers, directors, 
            employees, contractors, agents, Licensors, suppliers, successors and assigns from 
            and against any claims, liabilities, damages, judgments, awards, losses, costs, 
            expenses or fees (including reasonable legal fees) arising out of or relating to your 
            violation of these Terms of Use or your use of the Portal, including, but not limited to, 
            your User Contributions, any use of the Portal’s content, services and products other 
            than as expressly authorised in these Terms of Use, or your use of any information 
            obtained from the Portal. 
          </p>

        <h2>29. Governing Law and Jurisdiction</h2>

        <p>
          All matters relating to the Portal and these Terms of Use, and any dispute or claim 
          arising therefrom or related thereto (in each case, including non-contractual disputes 
          or claims), shall be governed by and construed in accordance with the laws of 
          England and Wales without giving effect to any choice or conflict of law provision or 
          rule (whether of England and Wales or any other jurisdiction). 
        </p>

        <p>
          Any legal suit, action or proceeding arising out of, or related to, these Terms of Use or 
          the Portal shall be instituted exclusively in the courts of England and Wales. You waive 
          any and all objections to the exercise of jurisdiction over you by such courts and to 
          venue in such courts. 
        </p>

        <h2>30. Arbitration </h2>

        <p>
          Any dispute arising out of or relating to these Terms of Use or use of the Portal 
          (including disputes arising from or concerning their interpretation, violation, invalidity, 
          non-performance, or termination) shall be resolved in accordance with Section 20 
          (Dispute Resolution & Mediation) and, where proceedings are commenced, in the 
          courts of England and Wales. 
        </p>

        <h2>31. Limitation on Time to File Claims</h2>
        <p>
          Any cause of action or claim you may have arising out of or relating to these Terms of 
          Use or the Portal must be commenced within one (1) year after the cause of action 
          accrues; otherwise, such cause of action or claim is permanently barred. 
        </p>

        <h2>32. Waiver and Severability</h2>
        <p>
          No waiver by the Company of any term or condition set forth in these Terms of Use 
          shall be deemed a further or continuing waiver of such term or condition or a waiver of 
          any other term or condition, and any failure of the Company to assert a right or 
          provision under these Terms of Use shall not constitute a waiver of such right or 
          provision. 
        </p>

      <p>
        If any provision of these Terms of Use is held by a court or other tribunal of competent 
        jurisdiction to be invalid, illegal or unenforceable for any reason, such provision shall 
        be eliminated or limited to the minimum extent such that the remaining provisions of 
        the Terms of Use will continue in full force and effect. 
      </p>

      <h2>33. Entire Agreement</h2>

      <p>
        The Terms of Use constitute the sole and entire agreement between You and the 
        Company with respect to the Portal and supersede all prior and contemporaneous 
        understandings, agreements, representations and warranties, both written and oral, 
        with respect to the Portal.
      </p>

      <NavLink
            to={"/signup"}
            title={''}
            className={({ isActive }) =>
              "header-link" + (isActive ? " active" : " ")
            }
            end
          >
      <Button
            variant="outlined"
            color="primary"
            type="submit"
            sx={{ mt: 2 }}
            onClick={handleAgreeClick}
          >
            I Agree
          </Button>
          </NavLink>
    </Card>
  );
};

